<script setup>
import ShowScheduleVerticalTile from '@components/show-schedule-vertical-tile'

defineProps({
    resources: {
        type: Array,
        default: () => [],
    },
})
</script>

<template>
    <div class="show-schedule-mix-block">
        <ShowScheduleVerticalTile
            v-for="resource in resources"
            :key="`${resource.id}${resource.scheduled_start_time}`"
            :playlist-item="resource"
            artwork
        />
    </div>
</template>

<style lang="scss" scoped>
@use 'sass:math';
@use '@design' as *;

.show-schedule-mix-block {
    min-height: 14rem;
    padding-bottom: math.div($s-h, 2);
}
</style>
